import request from "../request";

export const auditLogAction = async (env, action, metadata = null) => {
	await request({
		url: `/${env}/audit-log-action/`,
		method: "POST",
		data: {
			action,
			metadata,
			env,
		},
	});
	return;
};
